import React from 'react';

import { SIMPLIFIED_TWELVE_HOUR_TIME_PARSE_FORMAT } from 'features/store/constants';
import { readableTimeInterval } from 'features/store/utils';
import { StyleSheet, View } from 'react-native';

import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

import { InnerHeader, InnerText } from '../styled';
import { IHoursProps } from '../types';

const storeHoursSummary: [TranslationKey, string][] = [
  ['monday', 'mon'],
  ['tuesday', 'tue'],
  ['wednesday', 'wed'],
  ['thursday', 'thr'],
  ['friday', 'fri'],
  ['saturday', 'sat'],
  ['sunday', 'sun'],
];

export const Hours = ({ title, hours }: IHoursProps) => {
  const hoursOfOperation = readableTimeInterval({
    fallbackMessage: t('hoursOfOperationFallbackMessage'),
    open24HoursMessage: t('open24Hours'),
    timeFormat: SIMPLIFIED_TWELVE_HOUR_TIME_PARSE_FORMAT,
  });

  if (!hours) {
    return null;
  }

  return (
    <View style={styles.hoursSection}>
      <InnerHeader accessibilityLevel={2} variant="headerThree">
        {title}
      </InnerHeader>
      {storeHoursSummary.map(([messageId, abbreviatedDay]) => {
        const hoursRecord = hours as Record<string, string>;
        const openingHours = hoursRecord[`${abbreviatedDay}Open`];
        const closingHours = hoursRecord[`${abbreviatedDay}Close`];
        return (
          <View key={messageId} style={styles.storeHourRow}>
            <InnerText style={styles.hourDay}>{t(messageId)}</InnerText>
            <InnerText style={styles.hourTime}>
              {hoursOfOperation(openingHours, closingHours)}
            </InnerText>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  hoursSection: {
    paddingHorizontal: 24,
    paddingTop: 14,
    paddingBottom: 16,
  },
  storeHourRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  hourDay: {
    flex: 1,
  },
  hourTime: {
    textAlign: 'right',
  },
});
